import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: 16,
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginBottom: 10,
  },
  subLabel: {
    fontSize: 12,
    color: theme.palette.primary.main,
    marginBottom: 10,
    marginLeft: 5,
  },
  input: {
    backgroundColor: theme.palette.white,
  },
}))

export default useStyles
